/**
 * 后台数据转前台数据
 * 前端变量定义使用驼峰式, 例如：gameId
 */
/* eslint-disable */
import { dateFormat, recursionTrans, uniqueId, isArray } from "../common/util.js";
import questionCvt from "./questionCvt.js";
import personManageCvt from "./pageServices/personManageCvt.js";
import clusterPageCvt from "./pageServices/clusterPageCvt.js";
import materialLibraryCvt from './pageServices/materialLibraryCvt.js'
import i18n from "@/i18n";

// 转换提交业务并发送邮件数据
function transBusinessAndEmailInfo(result) {
    return {
        gameId: result.game_id,
        gameName: result.game_name
    };
}

// 心悦所有游戏列表数据转换
function transAllGameList(result) {
    let ret = [];
    ret = result.detail.map(data => {
        return {
            gId: data.gid,
            name: decodeURIComponent(data.gname),
            picUrl: ""
        };
    });
    return ret;
}

// 当前用户已申请的业务数据
function transBusinessOwners(result) {
    return result.map(function(data) {
        return {
            gameStatus: "hasBusiness",
            gameId: data.game_id,
            gameName: data.game_name,
            extendGameId: data.extend_game_id,
            gamePic: data.game_pic
        };
    });
}

// 首页-直属领导数据获取
function transUserLeaderInfo(result) {
    let ret = {
        leaderEngName: result.EngName,
        leaderChnName: result.ChnName
    };
    return ret;
}

// 左边菜单栏数据
function transLeftMenu(result) {
    return recursionTrans(
        result,
        function(menuData) {
            if (menuData.iconUrl && menuData.iconUrl.indexOf("./static/images/") != -1) {
                menuData.iconUrl = menuData.iconUrl.replace("./static/images/", "//ossweb-img.qq.com/images/xiaoyue/images/manager/website/");
            }

            return menuData;
        },
        "subMenu"
    );
}

// 问题列表数据获取
function transQuestionList(result) {
    let ret = {
        standTotal: result.std_quest_total,
        dataset: []
    };

    ret.dataset = result.corpus.map(function(data) {
        return {
            check: false,
            questionId: data.question_id,
            standQuestion: { value: data.question, tips: i18n.t("zhiji.hotSpot.quesTip") },
            creator: data.creator,
            createrTime: data.create_time,
            state: getStateLabel(data),
            operator: getOperators(data),
            rowId: data.question_id,
            addData: {
                recommendSimilar: data.recommended_count === 0 ? false : true,
                rowId: data.question_id,
                sceneId: data.set_id,
                similarQuestion: { value: data.ext_quest_count, tips: i18n.t("zhiji.knowlege.quesEditModal.editSimilar") },
                langType: data.lang,
            }
        };
    });

    return ret;
}

function getStateLabel(qs) {
    const isFirstAnswerScene = qs.set_id == 1 || qs.set_id == 1001;

    return isFirstAnswerScene ? getFirstStateLabel(qs) : getOtherStateLabel(qs.status);
}

function getFirstStateLabel(qs) {
    if (qs.is_default) {
        return 'first';
    } else if (qs.no_answer_question) {
        return 'reveal';
    };
    return getOtherStateLabel(qs.status);
}

function getOtherStateLabel(status) {
    const statusObj = {
        0: i18n.t("zhiji.common.delete"),
        1: i18n.t("zhiji.knowlege.alreadyOn"),
        2: i18n.t("zhiji.knowlege.alreadyOff"),
        3: i18n.t("zhiji.knowlege.draft")
    };
    return statusObj[status];
}

function getOperators(qs) {
    const isFirstAnswerScene = qs.set_id == 1 || qs.set_id == 1001;

    return isFirstAnswerScene ? getFirstAnswerOperators(qs) : getOtherOperators(qs.status);
}

function getFirstAnswerOperators (qs) {
    if (qs.is_default || qs.no_answer_question) return [];
    const statusObj = { 0: 'delete', 1: 'online', 2: 'offline' };
    const operators = ['setToFirst', 'setToReveal', 'online', 'offline', 'delete'];
    const statusIdx = operators.indexOf(statusObj[qs.status]);
    if (statusIdx !== -1) {
        operators.splice(statusIdx, 1);
        qs.status === 1 ? operators.splice(operators.indexOf(statusObj[0]), 1) : ''
        qs.status === 2 ? operators.splice(0,2) : '';
    }
    return operators;
}

// function getFirstAnswerOperators(qs) {
//     return qs.is_default ? [] : ["setToFirst", , "delete"];
// }

function getStatusObj() {
    return { 0: "delete", 1: "online", 2: "offline", 3: "draft" };
}

function getOtherOperators(status) {
    const statusObj = getStatusObj();
    let operators = ["transfer", "online", "offline", "delete"];
    const statusIdx = operators.indexOf(statusObj[status]);

    if (statusIdx !== -1) {
        operators.splice(statusIdx, 1);
        status === 1 ? operators.splice(operators.indexOf(statusObj[0]), 1) : "";
    }
    status === 3 ? operators.splice(operators.indexOf(statusObj[2]), 1) : "";
    return operators;
}

// 查询推荐相似问法数据转换
function transRecSimilarSearch(result) {
    let list = result.list.map(function(recSimlilar) {
        return {
            uId: uniqueId(),
            updateState: "",
            recSimilar: recSimlilar.question_extend,
            recSimilarId: recSimlilar.id
        };
    });

    return {
        count: result.count,
        list: list
    };
}

// 问题创建人列表转换
function transQuesCreator(result) {
    let ret = [{
        label: i18n.t("zhiji.knowlege.allCreator"),
        value: "all"
    }];

    ret.push(
        ...result.list.map(function(person) {
            return {
                label: person.creator,
                value: person.creator
            };
        })
    );

    return ret;
}

// 左边tree数据获取
function transTreesData(result) {
    return recursionTrans(
        result,
        function(treesData) {
            const isFirstAnswerScene = treesData.set_id == 1 || treesData.set_id == 1001;

            return {
                id: "" + treesData.set_id,
                evaNum: treesData.all_num ? treesData.all_num : "", // 评价总数
                satisfaction: treesData.good_rate_print ? treesData.good_rate_print : "", // 满意度
                smallLabel: "" + treesData.set_id,
                label: treesData.set_name,
                level: treesData.set_level,
                editFlags: isFirstAnswerScene ? ["edit", "move"] : null
            };
        },
        "nodes",
        "children"
    );
}

// 批量导入数据处理
function transBatchImportData(result) {
    let ret = {
        failAnswer: result.failure_answer_id_count,
        failExtQuestion: result.failure_ext_question_id_count,
        failQuestion: result.failure_question_id_count,
        failDetails: [],
        successAnswer: result.success_answer_id_count,
        successExtQuestion: result.success_ext_question_id_count,
        successQuestion: result.success_question_id_count
    };

    ret.failDetails.push(
        ...result.failure_arr.map(fail => {
            return {
                errInfo: fail.err_info,
                row: fail.failure_rows
            };
        })
    );

    return ret;
}

// 单个问题详细信息获取
function transQuesDetail(result) {
    return {
        info: questionCvt.cvtQuesInfo(result),
        answers: questionCvt.cvtAnswerList(result)
    };
}

// 相似问法列表转换
function transSimilarDetail(result) {
    return {
        similarTotal: result.all_count,
        matchSimilarTotal: result.match_count,
        similar: questionCvt.cvtSimilarList(result)
    }
}

// 问题列表获取，包含问题，场景名称
function transQuesSimpleList(result) {
    return {
        hasMore: result.more,
        quesList: result.res.map(function(qs) {
            return {
                questionId: qs.id,
                question: qs.question,
                sceneLevel1: qs.one_set_name,
                sceneLevel2: qs.second_set_name,
                optionTip: qs.fast_name
            };
        })
    };
}

// 问题文本展示内容转换
function transQuesSimpleText(result) {
    return {
        answerText: result.answer_text
    };
}

// 获取用户内容转换
function tranUserInfo(resp) {
    return {
        parentId: resp.ParentID,
        chnName: resp.ChnName,
        deptNameString: resp.DeptNameString,
        engName: resp.EngName,
        userIcon: `https://dayu.oa.com/avatars/${resp.EngName}/profile.jpg`
    };
}

// 外部人员申请接入转换
function transOuterSubmitData(result) {
    return result;
}

// 外部人员申请状态数据和所属业务数据转换
function transOuterApplyStatus(result) {
    const statusArr = ["noApply", "waitForCheck", "hasBusiness"];
    let allGames = [];

    result.game.forEach(function(game) {
        allGames.push({
            gameId: game.game_id,
            gameName: game.game_name,
            gamePic: game.game_pic,
            gameStatus: statusArr[2]
        });
    });

    let waitForCheckGames = result.application.filter(function(apply) {
        return statusArr[apply.status] != "hasBusiness";
    });

    waitForCheckGames.forEach(function(apply) {
        allGames.push({
            gameId: apply.game_id,
            gameName: apply.game_name,
            gamePic: apply.game_pic || "",
            gameStatus: statusArr[apply.status]
        });
    });

    return allGames;
}

function transOuterLogout(result) {
    return result === "注销成功" ? "success" : "fail";
}

// 答案属性数据转换
function transAnswerPropData(result) {
    return {
        userPortrait: questionCvt.cvtPortraitProp(result)
    };
}

// 推荐快捷栏数据转换
function transRecommendShortbar(result) {
    return (
        result &&
        result.list.map(item => {
            return {
                name: item.fast_name,
                optionType: "question",
                question: item.question,
                questionId: item.question_id,
                uId: uniqueId(),
                updateState: "add",
                recommend: true
            };
        })
    );
}

// 账号管理列表转换
function transAccountList(result) {
    return personManageCvt.accountData2Client(result);
}

// 所有组别列表转换
function transGroupOption(result) {
    return personManageCvt.allGroupOption2Client(result);
}

// 分组管理列表转换
function transGroupList(result) {
    return personManageCvt.groupData2Client(result);
}

// 角色管理列表转换
function transRoleList(result) {
    return personManageCvt.roleListData2Client(result);
}

// 所有角色信息转换
function transRoleOption(result) {
    return personManageCvt.allRoleOption2Client(result);
}

// 角色管理：权限列表数据转换
function transPermitList(result) {
    return personManageCvt.permitList2Client(result);
}

// 问答日志列表数据转换
function transAskAnswerLog(result) {
    let logData = {
        userCount: result.question_count,
        count: result.count,
        tableData: [],
    }
    let questionTypeObj = {
        "first_ask": i18n.t("zhiji.robotLog.initQues"),
        "input": i18n.t("zhiji.robotLog.byTyping"),
        "click": i18n.t("zhiji.robotLog.byClick")
    }
    logData.tableData = result.list.map((item) => {
        let shortcutBar = item.shortcut_bar && JSON.parse(item.shortcut_bar);
        return {
            rowId: uniqueId(),
            time: dateFormat(new Date(item.created_at * 1000)),
            sessionId: item.session_id,
            accountId: item.user_id,
            questionType: questionTypeObj[item.question_type] || "",
            userQuestion: item.question,
            sensitiveWord: cvtSensitiveWord(item.sensitive_words),
            scenes: item.set_array,
            questionId: item.question_id,
            standQuestion: item.match_question.split("(")[0],
            answer: item.answer_text,
            operate: {
                userId: item.user_id,
                answerDetail: item.answer,
            },
            addData: {
                enUserQuestion: item.trans_en_question,
                enStandQuestion: item.en_question,
                enAnswerDetail: item.en_answer,
                lang: item.dect_lang,
                userId: item.user_id,
                answerDetail: item.answer,
                shortcutBar: shortcutBar ? shortcutBar : [],
                showOption: shortcutBar && shortcutBar.length > 0 ? "OptionShape" : ""
            }
        }
    });
    return logData;
}

// 敏感词列特殊处理
function cvtSensitiveWord(words) {
    if (!words || words == "null" || !JSON.parse(words).join(",")) {
        return "";
    } else {
        return JSON.parse(words).join(",");
    }
}

// 同语义问题状态数据转换
function transSynonymQuestions(result) {
    const statusObj = getStatusObj();
    return result.map(question => {
        return {
            lang: question.lang,
            questionId: question.question_id,
            status: statusObj[question.status],
            statusLabel: getOtherStateLabel(question.status)
        }
    });
}

// 首屏推荐数据转换
function transFirstRecom(result) {
    const statusObj = { 1: "online", 2: "offline", 3: "draft" }

    let ret = [];
    ret = result.map(item => {
        return {
            ...item,
            status: statusObj[item.status],
            content: item.content && cvtFirstQuesList(item.content)
        }
    });
    return ret;
}

// 内容助手：首屏推荐内容数据格式转换
function transRecomResource(result) {
    const statusObj = {
        1: "online",
        2: "offline",
        3: "draft"
    }
    let ret = [];
    ret = result.map(item => {
        return {
            ...item,
            status: statusObj[item.status],
            content: item.content && cvtRecomResourceList(item.content)
        }
    });
    return ret;
}
// 内容助手：recommendResourceList数据转换
function cvtRecomResourceList(data) {
    let ret = [];
    ret = JSON.parse(data).map(item => {
        let itemType = {
            "video": "VideoItem",
            "tip": "StrategyItem"
        }
        return {
            ...item,
            uId: uniqueId(),
            wtType: itemType[item.type],
            id: item.resource_id,
            cardImage: item.image,
            title: item.name,
            videoUrl: item.url,
            videoId: item.video_id,
            duration: item.vt,
            videoSize: item.vsize
        }
    });
    return ret;
}

// 首屏语列表数据转换
function cvtFirstQuesList(data) {
    let ret = [];
    ret = JSON.parse(data).map(item => {
        return {
            uId: uniqueId(),
            firstName: item.name,
            secondName: item.second_name,
            question: item.question,
            questionId: item.question_id
        }
    });
    return ret;
}

// 聚类卡片列表转换
function transCardsData(result) {
    return clusterPageCvt.clusterCards2Client(result);
}

// 聚类：常规闭环数据转换
function transConventional(result) {
    return clusterPageCvt.conventional2Client(result);
}

// 聚类管理-日志详情数据转换
function transLogDetailData(result) {
    return clusterPageCvt.logDetail2Client(result);
}

function transErrorData(error) {
    return {
        errCode: error.err_code,
        errMessage: error.err_msg,
        result: error.result,
    }
}

// 敏感词分类列表数据转换
function transSensitiveData(result) {
    let sensitiveData = {
        totalGroups: result.count,
        groupListData: []
    }
    let statusObj = { 0: "offline", 1: "online", 3: "draft" }
    sensitiveData.groupListData = result.list && result.list.map(item => {
        return {
            ...item,
            uId: uniqueId(),
            createdTime: item.created_at,
            updateTime: item.updated_at,
            status: statusObj[item.status],
            wordsArr: cvtSensitiveWords(item.words)
        }
    });

    return sensitiveData;
}

// 敏感词列表
function cvtSensitiveWords(words) {
    let ret = [];
    words ? (ret = words.split(",")) : "";
    ret = ret.map(word => {
        return {
            uId: uniqueId(),
            checked: false,
            updateState: "add",
            word: word
        }
    });

    return ret;
}

// VLink图片库列表数据转换
function transVLinkPicture(result) {
    return materialLibraryCvt.cvtPictureListData(result);
}

export default {
    transLeftMenu,
    transQuestionList,
    transQuesCreator,
    transTreesData,
    transBatchImportData,
    transQuesDetail,
    transQuesSimpleList,
    transUserLeaderInfo,
    transBusinessOwners,
    transBusinessAndEmailInfo,
    transQuesSimpleText,
    transAllGameList,
    tranUserInfo,
    transOuterSubmitData,
    transOuterApplyStatus,
    transOuterLogout,
    transRecSimilarSearch,
    transAnswerPropData,
    transRecommendShortbar,
    transAccountList,
    transGroupList,
    transRoleList,
    transGroupOption,
    transRoleOption,
    transAskAnswerLog,
    transPermitList,
    transSynonymQuestions,
    transFirstRecom,
    transRecomResource,
    transCardsData,
    transConventional,
    transLogDetailData,
    transErrorData,
    transSensitiveData,
    transSimilarDetail,
    transVLinkPicture
};
